import React from "react";
import styled from "styled-components";
// Assets
import HeaderImage from "../../assets/brand/profile.jpg";
import Dots from "../../assets/svg/Dots";

export default function Header() {
  return (
    <Wrapper id="home" className="container flexSpaceCenter">
      <LeftSide className="flexCenter">
        <div>
          <h1 className="extraBold font60">José Salvador Cortés Arteaga</h1>
          <HeaderP className="font13" style={{ paddingBottom: 0 }}>
            Director de BDM | Especialista en Marketing, <b>Social Listening</b>, <b>Minería de Datos</b>, <b>Medios Digitales</b>, <b>Content Manager</b> y <b>Social Advertising</b>.
          </HeaderP>
          <HeaderP className="font13">
            {
              'A lo largo de 10 años, Big Dream se ha consolidado como una compañía especializada en marketing político, colaborando con actores de distintos estados de la República Mexicana, así como con gobiernos municipales.\n\n' +
              'Nuestro enfoque estratégico en el análisis de redes sociales y la evaluación del impacto digital que estas plataformas tienen sobre la percepción y posicionamiento de los actores políticos, gubernamentales e institucionales, nos ha permitido desarrollar estrategias asertivas y campañas de alto nivel. A través de herramientas de monitoreo, segmentación de audiencias, diseño de contenidos y ads, la empresa ha contribuido en el fortalecimiento de la comunicación política y la presencia en línea de nuestros clientes, adaptándonos a las dinámicas sociales y electorales de cada región.\n\n' +
              'Creemos firmemente que para lograr grandes resultados se necesitan: Estrategia, Comunicación y Creatividad.'
            }
          </HeaderP>
        </div>
      </LeftSide>
      <RightSide>
        <ImageWrapper>
          <Img className="radius8" src={HeaderImage} alt="office" style={{zIndex: 9}} />
          <DotsWrapper>
            <Dots />
          </DotsWrapper>
        </ImageWrapper>
      </RightSide>
    </Wrapper>
  );
}


const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 50px 0;
  line-height: 1.5rem;
  white-space: pre-wrap;
  color: #111111;
  @media (max-width: 960px) {
    padding: 15px 0 50px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
const Img = styled.img`
  @media (max-width: 560px) {
    width: 80%;
    height: auto;
  }
`;
const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;


